module.exports = __webpack_public_path__ + "img/add-to-program.9bda1570.svg";